<template>
  <div id="Home">
    <Map />
  </div>
</template>

<script>
import Map from "@/components/Map";

export default {
  components: {
    Map
  }
};
</script>
